import { Radio, SxProps, Tooltip, Typography } from '@mui/material';
import Chip from '@mui/material/Chip';
import { findIndex } from 'lodash';
import React from 'react';
import { H, V } from '../../Layout';
import Loading from '../../components/Loading';
import FormLabel from '../FormLabel';

export enum RendererType {
    CHIPS,
    RADIO
}

type OptionsRendererProps = {
    value: any;
    label: string;
    options: any[];
    isOptionEqualToValue: (option, value) => boolean;
    onChange: (value) => void;
    size?: 'small' | 'medium';
    rendererType?: RendererType;
    loading?: boolean;
    containerSx?: SxProps;
    disabled?: boolean;
};
export default (props: OptionsRendererProps) => {
    const {
        value,
        label,
        options,
        onChange,
        size = 'medium',
        loading = false,
        rendererType = RendererType.CHIPS,
        isOptionEqualToValue,
        containerSx,
        disabled = false
    } = props;
    const isArray = Array.isArray(value);
    return (
        <V sx={{ width: '100%', gap: 1, mb: 1, ...containerSx }}>
            <FormLabel label={label} />
            <H
                sx={{
                    justifyContent: 'flex-start',
                    gap: rendererType === RendererType.CHIPS ? 2.5 : 0,
                    overflowX: 'hide',
                    flexWrap: 'wrap'
                }}
            >
                {loading ? (
                    <Loading size={'18px'} center={false} />
                ) : (
                    options.map((option, index) => {
                        const isOptionDisabled = disabled || option.disabled;
                        const isChecked = isArray
                            ? findIndex(value, (v) => isOptionEqualToValue(option, v)) > -1
                            : isOptionEqualToValue(option, value);
                        return rendererType === RendererType.RADIO ? (
                            <H
                                key={index}
                                className="clickable"
                                sx={{ mr: 1, maxWidth: '150px' }}
                                /**
                                 * @fixme Fix TS error
                                 */
                                onClick={() => {
                                    isChecked ? onChange(undefined) : onChange(option);
                                }}
                            >
                                <Radio checked={isChecked} disabled={isOptionDisabled} />
                                <Typography className={'ellipsis'}>{option.label}</Typography>
                            </H>
                        ) : (
                            <Tooltip key={index} title={option.label}>
                                <Chip
                                    sx={{ maxWidth: '150px', cursor: isOptionDisabled ? 'not-allowed' : 'pointer' }}
                                    size={size}
                                    color={isOptionDisabled ? 'default' : 'primary'}
                                    label={option.label}
                                    onClick={
                                        isOptionDisabled
                                            ? undefined
                                            : () => {
                                                  isChecked ? onChange(undefined) : onChange(option);
                                              }
                                    }
                                    variant={isChecked ? 'filled' : 'outlined'}
                                    disabled={option.disabled}
                                />
                            </Tooltip>
                        );
                    })
                )}
            </H>
        </V>
    );
};
